/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {Store} from '@gongxigames/framework/core';
import {FC, CanBeSignals, ContainerProps, getProp, PointLike, $Container} from '@gongxigames/framework/core/fragments/BuilderY';
import {Container, IHitArea, Point} from 'pixi.js';
import {DotButtonProps} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/components/slides/DotButton';

type DotButtonsProps = Omit<ContainerProps, 'position' | 'scale'> & CanBeSignals<{
    slides: Container[];
    activeIndex: number;
    setIndex: (i: number) => void;
    dotsPosition: Point;
    hitArea: IHitArea | null;
    dotOffset: number;
    dotButton: FC<DotButtonProps>;
}>;

export const $DotButtons: FC<DotButtonsProps> = (props) => {

    const position = Store.computed(() => {
        const dotsPosition = getProp(props.dotsPosition);
        const dotOffset = getProp(props.dotOffset);
        const slides = getProp(props.slides);

        const dotsOffset = -Math.max(slides.length - 1, 0) * dotOffset / 2;
        const x = (dotsPosition?.x ?? 0) + dotsOffset;
        const y = dotsPosition?.y ?? 0;

        return [x, y] as PointLike;
    });

    function onPress(i: number) {
        const setIndex = getProp(props.setIndex);

        setIndex(i);
    }

    const $DotButton = getProp(props.dotButton) as any;

    const dots = Store.computed(() => {

        const slides = getProp(props.slides);
        const activeIndex = getProp(props.activeIndex);
        const dotOffset = getProp(props.dotOffset);

        const dots = [];

        for (let i = 0; i < slides.length; i++) {
            const isActive = i !== activeIndex;
            const offset = i * dotOffset;

            dots.push(<$DotButton hitArea={props.hitArea} active={isActive} onPress={() => onPress(i)} position={[offset, 0]} />);
        }
        return dots;
    });

    return <$Container name='dots' position={position}>{dots}</$Container>;
};
